import React from "react";
import MainSwitch from "./components/nav/mainSwitch";
import Updater from "./components/newVersion/Updater";

export default () => (
  <>
    <Updater />
    <MainSwitch />
  </>
);
